import { Coins, Savings } from "../../assets/svg/Svgs";
import { useAuth } from "../../components/context/AuthContext";
import { updateGlobalContext } from "../../components/context/GlobalContext";
import { FundSourceCard } from "../../components/elements/CardElements";
import { showConfetti } from "../../components/elements/ConfettiView";
import { API_WALLET_TRANSFER } from "../../constants/apis";
import {
  COMPONENT,
  MOBILE_TO_WALLET,
  TEXT,
  WALLET_TO_MOBILE,
  WITHDRAW,
} from "../../constants/constants";
import { PropOptions } from "../../utils/formUtils";
import { transactionPinField } from "../../utils/pinUtils";

export const useWalletsForm = ({ source }: any) => {
  const { user } = useAuth();
  const { phone_number } = user || {};

  const isWithdraw = source === WITHDRAW;

  const fields = [
    {
      type: COMPONENT,
      component: (
        <div className="textCenter">
          <img src={isWithdraw ? Coins : Savings} height={150} alt="wallet" />
        </div>
      ),
    },
    {
      type: COMPONENT,
      component: (
        <div className="textCenter font12 grey">
          {isWithdraw
            ? "Withdraw from your wallet to your mobile money."
            : "Deposit to your wallet with mobile money."}
        </div>
      ),
    },
    {
      field: "phone_number",
      type: TEXT,
      required: true,
      props: { disabled: isWithdraw },
    },
    {
      field: "amount",
      type: TEXT,
      required: true,
      props: { prefix: "UGX", ...PropOptions.number },
    },
    // Top-ups (mobile→wallet) don't need the PIN — money coming in is
    // confirmed by the MoMo prompt on the user's phone.
    { ...transactionPinField, visible: isWithdraw, required: isWithdraw },
    {
      type: "component",
      component: <FundSourceCard />,
      visible: isWithdraw,
    },
  ];

  const onSubmit = ({ payload }: any) => {
    // const suffix = isWithdraw ? WITHDRAW : "top-up";
    // const api = `${API_WALLETS}${walletId}/${suffix}/`;

    const action = isWithdraw ? WALLET_TO_MOBILE : MOBILE_TO_WALLET;
    let phone_number: string = payload?.phone_number?.replaceAll(" ", ""); // remove spaces

    if (phone_number?.startsWith("+256")) {
      phone_number = phone_number?.replace("+256", "0");
    }

    return {
      api: API_WALLET_TRANSFER,
      params: { ...payload, phone_number, action },
      successMessage: {
        message: "Transaction initiated successfully",
        duration: 7,
      },
      onSuccess: (data: any) => {
        const { id, status } = data?.data || {};
        // start polling for pending transactions
        updateGlobalContext({
          reload_transactions: {
            status,
            id,
          },
        });

        showConfetti(); // show confetti
      },
    };
  };

  return {
    fields,
    onSubmit,
    submitText: isWithdraw ? "Withdraw" : "Continue",
    defaultValues: { phone_number },
  };
};
